import React from 'react';
import PropTypes from 'prop-types';

import { Button, Form, FormRow } from '@appfolio/react-gears';

class ForgotPasswordForm extends React.Component {
  state = {
    username: this.props.username,
    usernameError: '',
  };

  submit = (e) => {
    e.preventDefault();
    const { validator } = this.props;
    const { username } = this.state;

    validator.validate({ username });

    if (validator.valid) {
      this.setState({ usernameError: '' });
      this.props.onSubmit({ username });
    } else {
      this.setState(validator.errors);
    }
  }

  render() {
    const { readOnly } = this.props;

    return (
      <Form noValidate onSubmit={this.submit}>
        <FormRow
          id="usernameInput"
          name="username"
          placeholder="john.smith@email.com"
          label="Email"
          labelSize="lg"
          size="lg"
          type="email"
          color={this.state.usernameError ? 'danger' : null}
          feedback={this.state.usernameError}
          value={this.state.username}
          onChange={e => this.setState({ username: e.target.value })}
          stacked
          readOnly={readOnly}
          autoComplete="off"
        />
        <Button
          type="submit"
          size="lg"
          color="primary"
          disabled={readOnly}
          className="p-3 w-100 mt-3 mb-3"
        >
          Send Reset Password Email
        </Button>
      </Form>
    );
  }
}

ForgotPasswordForm.propTypes = {
  readOnly: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  validator: PropTypes.shape({ validate: PropTypes.func }).isRequired,
  username: PropTypes.string,
};

ForgotPasswordForm.defaultProps = {
  readOnly: false,
  username: '',
};

export default ForgotPasswordForm;
